import { useState } from "react"
import { isWcmEditor } from "../../../../../config/serverConfig"
import { videoSourceOption } from "../../../topStory/windows/contentWindow/videoLiveSourceSelector"
import { LiveVideoPlayer } from "../../../ynet1280/liveVideoPlayer/components/liveVideoPlayer";

interface FloatingVideoProps {
    videoSource: videoSourceOption
    videoTitle: string
    isMobileWeb?: boolean
    hideVideoAds?: boolean
    shouldAudioAutoplay?: boolean
    poster?: string
}

export const FloatingVideo = (props: FloatingVideoProps) => {
    const { videoSource, videoTitle, hideVideoAds } = props
    const [isFloatingPlayerVisible, setIsFloatingPlayerVisible] = useState(true)
    const setPlayer = () => {
        if (isWcmEditor()) return;
        setIsFloatingPlayerVisible(!isFloatingPlayerVisible)
    }

    const onIsFloatingPlayerVisibleChange = (isOpen: boolean) => {
        setIsFloatingPlayerVisible(isOpen)
    }

    return (
        <>
            <button onClick={setPlayer} className="floatingPlayerBtn"></button>
            {!isWcmEditor() && isFloatingPlayerVisible &&
                <LiveVideoPlayer
                    isLogoExist={true}
                    videoTitle={videoTitle}
                    liveVideoSource={videoSource}
                    videoAutoPlay={props.shouldAudioAutoplay}
                    videoMuteSound={false}
                    videoShowSoundBtn={true}
                    videoShowControlPanel={true}
                    isMinimizedVisible={false}
                    videoType={"bepo"}
                    hideVideoAds={hideVideoAds}
                    poster={props.poster}
                    thisLocation=""
                    externalIsOpenTrigger={true}
                    onExternalIsOpenTriggerChange={onIsFloatingPlayerVisibleChange}
                />
            }
        </>
    )
}

FloatingVideo.siteScriptName = "FloatingVideo"